module.exports = __webpack_public_path__ + "img/Mask Group 140.6d2b151d.svg";